import script from "./CompanyUserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyUserPage.vue?vue&type=script&setup=true&lang=js"

import "./CompanyUserPage.vue?vue&type=style&index=0&id=088cdd5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088cdd5c"]])

export default __exports__